import { render, staticRenderFns } from "./QueueCard.vue?vue&type=template&id=04a35f2b&scoped=true&lang=pug"
import script from "./QueueCard.vue?vue&type=script&lang=js"
export * from "./QueueCard.vue?vue&type=script&lang=js"
import style0 from "./QueueCard.vue?vue&type=style&index=0&id=04a35f2b&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a35f2b",
  null
  
)

export default component.exports